/**
 * @generated SignedSource<<f827edd359fdf0b306f733282e6b75ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferWrapper_transaction$data = {
  readonly isNegotiable: boolean | null;
  readonly isPrivateOffer: boolean | null;
  readonly " $fragmentType": "CheckoutWireTransferWrapper_transaction";
};
export type CheckoutWireTransferWrapper_transaction$key = {
  readonly " $data"?: CheckoutWireTransferWrapper_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferWrapper_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferWrapper_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateOffer",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "9e7c02d8ec891a378a0f660e46e363c2";

export default node;
